import React from 'react'
import PropTypes from 'prop-types'
import { EditTournamentForm } from 'local/components'

const TournamentsAddComponent = ({ onSubmit }) => (
  <EditTournamentForm
    header="Add Tournaments"
    onSubmit={onSubmit}
    initialValues={{}}
  />
)

TournamentsAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default TournamentsAddComponent
